import {msFormat} from '@/commons/msFormat';
import {useCustomDashboard} from '../dashboard/customDashboard';
import dashboardDataApi from '@/apis/dashboard/dashboardDataApi';
import _ from 'lodash';
import commonFunction from '@/commons/commonFunction';
import moment from 'moment';
import {useBankInfoStore} from '@/stores/dictionary/bankInfoStore';
import {useBudgetSourceStore} from '@/stores/dictionary/budgetSourceStore';
import {useAccountingObjectStore} from '@/stores/dictionary/accountingObjectStore';
import {useSUAccountTransferStore} from '@/stores/summary/suAccountTransferStore.js';
import {useContextStore} from '@/stores/contextStore';
import {useFAVoucherCustomStore} from '@/stores/faVoucher/faVoucherCustomStore';
import faVoucherDepreciationAPI from '@/apis/fa/faVoucherDepreciationAPI';
import popupUtil from '@/commons/popupUtil';
import suGeneralVoucherApi from '@/apis/su/suGeneralVoucherAPI.js';
import {ref, onMounted} from 'vue';
import BusinessType from '@/commons/wildcards/constants/AccountTransferBusinessType.js';
import RefType from '@/commons/wildcards/constants/RefType';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';

export const avaFunctionCalling = proxy => {
  const {getCustomOption} = useCustomDashboard();
  let reportHistory = {};
  const UnitMoney = [
    {
      text: 'Đồng',
      val: 1,
    },
    {
      text: 'Nghìn đồng',
      val: 1000,
    },
    {
      text: 'Triệu đồng',
      val: 1000000,
    },
    {
      text: 'Tỷ đồng',
      val: 1000000000,
    },
  ];
  const posted_date = commonFunction.getPostedDateFromLocalStorage() || new Date();
  /**
   * Vẽ grid cho báo cáo
   * @param {*} msgEle
   * @param {*} param
   * @param {*} botChat
   * @returns
   * pntoan 2.5.2024
   */
  const show_cash_grid_detail = async (msgEle, param, botChat) => {
    rememberMethod(show_cash_grid_detail, 'show_cash_grid_detail');
    const customParam = rememberOldParam(param);
    const paramReport = getParamForReport(customParam);
    let is_cash_payment_or_receipt = paramReport.is_cash_payment_or_receipt;
    let unit = paramReport.unit;
    let data = [];
    // Tiền gửi
    if (is_cash_payment_or_receipt.value == '1') {
      paramReport.chart_id = 1;
      let dataRaw = await dashboardDataApi.getDashboardReceiptExpenseAVA({param: JSON.stringify(paramReport)});
      if (paramReport?.bank_account_number?.value) {
        const accountData = dataRaw.find(e => e.title.contains(paramReport.bank_account_number.value));
        if (accountData) {
          data = [
            {
              title: 'Số dư cuối kỳ',
              debit_amount: accountData.debit_amount,
            },
          ];
        }
      } else {
        data = Array.from(dataRaw)
          .filter(
            x => x.dashboard_param_key == 'dashboard_receipt_expense' && x.dashboard_group == 1 && x.sort_order == 3,
          )
          .sort(function (a, b) {
            if (a.debit_amount < b.debit_amount) {
              return 1;
            }
            if (a.debit_amount > b.debit_amount) {
              return -1;
            }
            return 0;
          });
        data.forEach(e => {
          e['is_cash_payment_or_receipt'] = is_cash_payment_or_receipt;
        });
      }
    }
    // Tiền mặt
    else if (is_cash_payment_or_receipt.value == '2') {
      paramReport.chart_id = 2;
      let dataRaw = await dashboardDataApi.getDashboardReceiptExpenseAVA({param: JSON.stringify(paramReport)});
      const result = {};

      // Iterate over the data array
      dataRaw.forEach(item => {
        const {title, debit_amount} = item;
        // Check if title already exists in result
        if (result[title]) {
          // If exists, add amount to existing total
          result[title] += debit_amount;
        } else {
          // If not, initialize with current amount
          result[title] = debit_amount;
        }
      });

      // Convert result object to an array of objects
      data = Object.keys(result).map(title => ({title, debit_amount: result[title], is_cash_payment_or_receipt}));
    } else {
      cash_payment_receipt_report(msgEle, param, botChat);
      return;
    }
    if (unit) {
      data = data.map(e => {
        e.debit_amount = e.debit_amount / unit;
        return e;
      });
    }
    if (data?.length == 0) {
      const item = {
        message: 'Không có dữ liệu',
      };
      window._aiBot.renderBotChatText(item, botChat);
      return;
    }
    msgEle = $(getMsgGrid());
    msgEle.appendTo(botChat);
    const table = renderGrid(data, botChat);
    const avaBambooChart = $(msgEle).find('.ava-bamboo-grid');
    if (avaBambooChart) {
      $(avaBambooChart).append(table);
    }
  };
  /**
   * Vẽ grid để hiển thị số liệu
   * @param {*} data
   * @returns
   * pntoan 25.4.2024
   */
  const renderGrid = (data, botChat) => {
    const table = document.createElement('table');
    const tbody = document.createElement('tbody');
    const thead = document.createElement('thead');
    const rowHeader = document.createElement('tr');
    const keyCellHeader = document.createElement('th');
    const valueCellHeader = document.createElement('th');
    keyCellHeader.textContent = 'Nội dung';
    keyCellHeader.classList.add('text-left');
    valueCellHeader.textContent = 'Số tiền';
    valueCellHeader.classList.add('text-right');
    rowHeader.append(keyCellHeader);
    rowHeader.append(valueCellHeader);
    thead.append(rowHeader);

    data.forEach(item => {
      const row = document.createElement('tr');
      const keyCell = document.createElement('td');
      const valueCell = document.createElement('td');

      keyCell.textContent = item.title;
      valueCell.textContent = msFormat.formatAmount(item.debit_amount);
      valueCell.classList.add('text-right');
      if (item.sort_order == 1) {
        keyCell.classList.add('parent');
        valueCell.classList.add('parent');
      }
      if (item?.is_cash_payment_or_receipt) {
        let itemSubmit = {
          message: item.title,
          notRemoveOption: true,
          option: true,
          optionGroup: true,
          valueSubmit:
            'Xem chi tiết số dư tiền ' +
            (item.is_cash_payment_or_receipt.value == '1' ? 'gửi ' : 'mặt ') +
            item.title.trim(),
        };
        keyCell.addEventListener('click', () => {
          window._aiBot.itemClick(itemSubmit, botChat);
        });
      }
      row.appendChild(keyCell);
      row.appendChild(valueCell);

      tbody.appendChild(row);
    });
    table.appendChild(thead);
    table.appendChild(tbody);
    table.classList.add('ava-table');
    return table;
  };
  const cash_payment_receipt_report = async (msgEle, param, botChat) => {
    rememberMethod(cash_payment_receipt_report, 'cash_payment_receipt_report');
    const customParam = rememberOldParam(param);
    const chart_id = 1;
    const paramReport = getParamForReport(customParam, chart_id);
    let unit = paramReport.unit;
    let unit_text = paramReport.unit_text;
    let dataRaw = await dashboardDataApi.getDashboardReceiptExpenseAVA({param: JSON.stringify(paramReport)});
    let data = [];
    if (dataRaw.some(x => x.debit_amount)) {
      data = dataRaw.filter(item => item.sort_order == 1 || item.sort_order == 2).map(x => x.debit_amount / unit);
    }

    if (data?.length == 0) {
      const item = {
        message: 'Không có dữ liệu',
      };
      window._aiBot.renderBotChatText(item, botChat);
      return;
    }
    msgEle = $(getMsgChart());
    msgEle.appendTo(botChat);
    let option = getCustomOption(
      'dashboard_receipt_expense',
      chart_id,
      proxy.$ms.constant.ChartType.Donut,
      unit_text,
      false,
    );
    var options = {
      series: data,
      chart: {
        height: 350,
        type: 'donut',
        toolbar: {
          show: false, // Ẩn thanh công cụ
        },
      },
      ...option.customOptions,
    };
    const total_cash = msFormat.formatAmountOC(data[1] + data[0]);
    const cash_payment = msFormat.formatAmountOC(data[1]);
    const cash_receipt = msFormat.formatAmountOC(data[0]);
    const period_text = paramReport.period_text.toLowerCase();
    const avaTextEle = $(msgEle).find('.ava-text');
    unit_text = unit_text.toLowerCase();
    $(avaTextEle).append(
      `Tổng số tiền đơn vị có là ${total_cash} ${unit_text}. Trong đó tiền mặt tại quỹ là ${cash_payment} ${unit_text}, tiền gửi ngân hàng là ${cash_receipt} ${unit_text}`,
    );
    const avaBambooChart = $(msgEle).find('.ava-bamboo-chart-data');
    var chart = new ApexCharts(avaBambooChart[0], options);
    chart.render();
    const chartHeader = $(msgEle).find('.ava-bamboo-chart-header');
    $(chartHeader).html(`<div class="ava-bamboo-chart-title">Số dư tiền mặt, tiền gửi ${period_text}</div>`);
    // Render option for report
    const optionHtml = $(msgEle).find('.ava-chart-option');
    const items = {
      category: undefined,
      // Đối với renderBotChatQuickReplies thì mặc định giá trị đầu tiên là câu hỏi rồi mới đến các option
      // Cho nên không muốn có câu hỏi thì phải để giá trị object đầu tiên rỗng
      payload: [
        {
          title: '',
        },
        {
          title:
            'Nếu bạn muốn xem tình hình sử dụng dự toán tại thời điểm khác vui lòng nhập liệu theo cú pháp: Đến ngày dd/mm/yyy',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title: 'Chọn lại đơn vị tính khác',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title: 'Xem chi tiết số dư tiền gửi',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title: 'Xem chi tiết số dư tiền mặt theo các quỹ tiền',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
      ],
      title: '',
      type: 'quickReplies',
    };
    window._aiBot.renderBotChatQuickReplies(items, optionHtml);
  };
  /**
   * Báo cáo tình hình dự toán ngân sách sử dụng năm
   * @param {*} msgEle
   * @param {*} param
   * @param {*} botChat
   * pntoan 22.4.2024
   */
  const budget_plan_report = async (msgEle, param, botChat) => {
    rememberMethod(budget_plan_report, 'budget_plan_report');
    const customParam = rememberOldParam(param);
    const chart_id = 2;
    let paramReport = getParamForReport(customParam, chart_id);
    let unit = paramReport.unit;
    let unit_text = paramReport.unit_text;
    let dataRaw = await dashboardDataApi.getDashboardBudgetPlanAVA({param: JSON.stringify(paramReport)});
    let data = [];
    if (dataRaw.some(x => x.debit_amount || x.credit_amount)) {
      data = [
        {
          name: 'Tạm ứng',
          data: dataRaw.map(x => x.debit_amount / unit),
        },
        {
          name: 'Thực chi',
          data: dataRaw.map(x => x.credit_amount / unit),
        },
      ];
    }
    if (data?.length == 0) {
      const item = {
        message: 'Không có dữ liệu',
      };
      window._aiBot.renderBotChatText(item, botChat);
      return;
    }
    msgEle = $(getMsgChart());
    msgEle.appendTo(botChat);
    let option = getCustomOption(
      'dashboard_budget_plan',
      chart_id,
      proxy.$ms.constant.ChartType.Column,
      unit_text,
      false,
    );
    var options = {
      series: data,
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false, // Ẩn thanh công cụ
        },
      },
      ...option.customOptions,
    };
    const debit_amount_object = data.find(e => e.name == 'Tạm ứng');
    let total_debit_amount = 0;
    if (debit_amount_object) {
      total_debit_amount = debit_amount_object.data[1];
    }
    total_debit_amount = msFormat.formatAmountOC(total_debit_amount);
    const credit_amount_object = data.find(e => e.name == 'Thực chi');
    let total_credit_amount = 0;
    if (credit_amount_object) {
      total_credit_amount = credit_amount_object.data[1];
    }
    total_credit_amount = msFormat.formatAmountOC(total_credit_amount);
    const avaTextEle = $(msgEle).find('.ava-text');
    unit_text = unit_text.toLowerCase();
    const period_text = paramReport.period_text.toLowerCase();
    const avaBambooChart = $(msgEle).find('.ava-bamboo-chart-data');
    $(avaTextEle).append(
      `<div>Tổng số tiền đơn vị đã tạm ứng trong kỳ là ${total_debit_amount} ${unit_text}</div>
      <div>Tổng số tiền đơn vị đã thực chi trong kỳ là ${total_credit_amount} ${unit_text}</div>`,
    );
    var chart = new ApexCharts(avaBambooChart[0], options);
    chart.render();
    const checked = paramReport.not_get_budget_item == 1 ? 'checked' : '';
    const chartHeader = $(msgEle).find('.ava-bamboo-chart-header');
    $(chartHeader).html(`<div class="ava-bamboo-chart-title">Tình hình sử dụng ngân sách ${period_text}</div>
    <div class="flex-row not-get-budget-item">
    <input type="checkbox" class="ms-checkbox-control" ${checked} onclick="return false;">
    <div>Không lấy số liệu 0051, 0052, 0099</div></div>`);
    // Render option for report
    const optionHtml = $(msgEle).find('.ava-chart-option');
    const items = {
      category: undefined,
      payload: [
        {
          title: '',
        },
        {
          title:
            'Nếu bạn muốn xem tình hình sử dụng dự toán tại thời điểm khác vui lòng nhập liệu theo cú pháp: Đến ngày dd/mm/yyy',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title:
            'Nếu bạn muốn xem chi tiết theo MLNS vui lòng nhập theo cú pháp: Loại MLNS - mã MLNS. Ví dụ: Chương - 800',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title: 'Chọn lại đơn vị tính khác',
          type: 'postback',
          value: '/budget_plan_report',
          notRemoveOption: true,
        },
        {
          title: 'Chọn Thực hiện lại không lấy số liệu 0051, 0052, 0099',
          type: 'postback',
          valueSubmit: 'không lấy số liệu 0051, 0052, 0099',
          notRemoveOption: true,
        },
      ],
      title: '',
      type: 'quickReplies',
    };
    window._aiBot.renderBotChatQuickReplies(items, optionHtml);
  };
  /**
   * Lấy các tham số cho báo cáo
   * @param {*} customParam
   * @param {*} chart_id
   * @returns
   * pntoan 2.5.2024
   */
  const getParamForReport = (customParam, chart_id) => {
    // Lấy tham số từ AVA truyền về
    let to_date = customParam.find(e => e.name == 'to_date');
    const unit_ava = customParam.find(e => e.name == 'unit');
    const not_get_budget_item_ava = customParam.find(e => e.name == 'not_get_budget_item');
    const budget_source = customParam.find(e => e.name == 'budget_source');
    const budget_chapter = customParam.find(e => e.name == 'budget_chapter');
    const budget_sub_kind_item = customParam.find(e => e.name == 'budget_sub_kind_item');
    const is_cash_payment_or_receipt = customParam.find(e => e.name == 'is_cash_payment_or_receipt');
    const get_data_type = customParam.find(e => e.name == 'get_data_type');
    const estimate_used_method = customParam.find(e => e.name == 'estimate_used_method');
    const bank_account_number = customParam.find(e => e.name == 'bank_account_number');
    const fund_code = customParam.find(e => e.name == 'fund_code');
    // Xào nấu lại chút
    let not_get_budget_item = false;
    let period_text = '';
    let from_date_year = posted_date.getFullYear() + '-01-01';
    let end_date_year = posted_date.getFullYear() + '-12-31';
    let from_date;
    let to_date_value;
    // Nếu to_date ko có dữ liệu thì mặc định là năm nay
    if (!to_date || (to_date && !to_date.value)) {
      to_date = {
        value: '500',
      };
    }
    // xét trường hợp người dùng nhập từ ngày .... đến ngày ....
    let date_range = to_date.value.split(',');
    if (date_range.length > 1) {
      from_date = date_range[0];
      to_date.value = date_range[1];
    } else {
      // trường hợp truyền vào là số thì enum
      if (!isNaN(to_date.value)) {
        var dateRange = proxy.$ms.commonFn.getDateRange(
          Number(to_date.value),
          {
            fromDate: posted_date,
            toDate: posted_date,
          },
          {isCheck: true, value: posted_date},
          'Period',
        );
        if (!dateRange.fromDate || !dateRange.toDate) {
          // Nếu mà dữ liệu ngày tháng sai thì mặc định là năm nay
          dateRange = proxy.$ms.commonFn.getDateRange(
            500,
            {
              fromDate: posted_date,
              toDate: posted_date,
            },
            {isCheck: true, value: posted_date},
            'Period',
          );
        }
        from_date = dateRange.fromDate;
        to_date_value = dateRange.toDate;
      }
      // Trường hợp còn lại là ngày tháng năm người dùng tự nhập
      else {
        let to_date_convert = new Date(to_date.value);
        to_date_value = moment(to_date_convert).format('YYYY-MM-DD');
      }
      if (from_date) {
        from_date_year = from_date;
      }
      // Nếu không có ngày bắt đầu thì mặc định là ngày bắt đầu của năm của ngày kết thúc
      else {
        from_date = new Date(to_date_value).getFullYear() + '-01-01';
        from_date_year = from_date;
      }
      period_text = proxy.$ms.commonFn.getTitleByDateRange(from_date, to_date_value, true);
      end_date_year = to_date_value;
    }
    if (not_get_budget_item_ava?.value) {
      not_get_budget_item = not_get_budget_item_ava.value == 'true' ? 1 : 0;
    }
    // Bắt đầu bind dữ liệu
    let unit = unit_ava?.value;
    // Nếu không có đơn vị tính thì mặc định
    if (!unit || unit == 'unknown') {
      switch (reportHistory.functionName) {
        // Số dư tiền mặt tiền gửi -> triệu đồng
        case 'cash_payment_receipt_report':
        case 'show_cash_grid_detail':
          unit = 1000000;
          break;
        // Tình hình dự toán được sử dụng trong năm -> tỷ đông
        case 'budget_plan_report':
          unit = 1000000000;
          break;
        default:
          unit = 1000000;
          break;
      }
    }
    let unit_text = UnitMoney.find(e => e.val == unit)?.text;

    let estimate_used_method_value = isNumber(estimate_used_method?.value) ? estimate_used_method?.value : 0;
    estimate_used_method_value = isInteger(estimate_used_method_value) ? estimate_used_method_value : 0;

    return {
      fromDate: from_date_year,
      toDate: end_date_year,
      option_print: 'ALL',
      get_data_type: get_data_type?.value || 2,
      budget_source_code: budget_source?.value || '##ALL##',
      budget_chapter_code: budget_chapter?.value || '##SUMMARY##',
      not_get_budget_item: not_get_budget_item || 0,
      estimate_used_method: estimate_used_method_value,
      budget_kind_item_code: budget_sub_kind_item?.value || '##ALL##',
      is_call_from_ava: true,
      chart_id: chart_id,
      unit: unit,
      unit_text: unit_text,
      is_cash_payment_or_receipt: is_cash_payment_or_receipt,
      bank_account_number: bank_account_number,
      fund_code: fund_code, // hiện tại vòng R4 chưa làm tới ( cứ lấy trước có gì về sau dùng thì dùng luôn )
      period_text: period_text,
    };
  };

  const isNumber = value => {
    return typeof value === 'number' && !isNaN(value);
  };

  const isInteger = value => {
    return Number.isInteger(value);
  };

  /**
   * Lưu lại phương thức in báo cáo vừa sử dụng lại để gọi thêm các tham số lần sau in thì in lại báo cáo đó kèm tham số mới
   * @param {*} callback
   * pntoan 2.5.2024
   */
  const rememberMethod = (callback, functionName) => {
    if (reportHistory) {
      reportHistory.method = callback;
      reportHistory.functionName = functionName;
    } else {
      reportHistory = {
        method: callback,
        functionName: functionName,
      };
    }
  };
  /**
   * Ghi nhớ lại các tham số cũ của báo cáo
   * @param {*} customParam
   * @returns
   * pntoan 2.5.2024
   */
  const rememberOldParam = customParam => {
    // Danh sách các tham số không lưu lại lịch sử ( VD như các tham số để xem chi tiết các tài khoản, quỹ tiền ) - cái này tuỳ thuộc vào nghiệp vụ BA để xem xét
    const paramRejected = ['fund_code'];
    // Mảng tham số để trả ra kết quả
    let resultParam = [];
    // Mảng tham số thao tác giá trị
    let tempParam = _.cloneDeep(reportHistory?.customParam);
    // Mảng tham số cũ để query
    const oldParam = reportHistory?.customParam;
    if (oldParam) {
      Array.from(customParam).forEach(e => {
        const param = Array.from(oldParam).find(item => item.name == e.name);
        if (param) {
          const index = Array.from(oldParam).findIndex(item => item.name == e.name);
          tempParam[index] = e;
        } else {
          tempParam.push(e);
        }
      });
    } else {
      tempParam = [...customParam];
    }
    // Lưu lại những tham số có thể lưu
    reportHistory.customParam = tempParam.filter(e => !paramRejected.includes(e.name));
    resultParam = tempParam;
    return resultParam;
  };
  /**
   * Thay đổi ngày xem của báo cáo
   * @param {*} msg
   * @param {*} param
   * @param {*} botChat
   * pntoan 22.4.2024
   */
  const change_property = (msg, param, botChat) => {
    if (reportHistory.method) {
      const customParam = rememberOldParam(param);
      reportHistory.method(msg, customParam, botChat);
    }
  };
  /**
   * Hiển thị danh sách các đơn vị có thể chuyển
   * @param {*} msg
   * @param {*} customParam
   * @param {*} botChat
   * pntoan 22.4.2024
   */
  const show_unit_options = async (msg, customParam, botChat) => {
    const unit_options = customParam.find(e => 'unit_options');
    const items = {
      category: undefined,
      payload: [],
      title: '',
      type: 'quickReplies',
    };
    if (unit_options && unit_options.value) {
      const unit_options_value = unit_options.value.split(',');
      Array.from(unit_options_value).forEach(e => {
        const unit_number = e.trim();
        if (!isNaN(unit_number)) {
          const unit_text = UnitMoney.find(e => e.val == Number(unit_number))?.text;
          let temp = {
            title: unit_text.toLowerCase(),
            type: 'postback',
            valueSubmit: 'Chọn đơn vị tính: ' + unit_text.toLowerCase(),
            notRemoveOption: true,
          };
          items.payload.push(temp);
        }
      });
    }
    if (items.payload.length > 1) {
      window._aiBot.renderBotChatQuickReplies(items, botChat);
    }
  };
  const getMsgChart = () => {
    return `<div>
    <div class="aib-bc-msg ava-text"></div>
    <div class="aib-bc-msg ava-bamboo-chart" style="width:100%">
      <div class="ava-bamboo-chart-header"></div>
      <div class="ava-bamboo-chart-data"></div>
    </div>
    <div class="ava-chart-option"></div>
    </div>`;
  };
  const getMsgGrid = () => {
    return `<div>
    <div class="ava-bamboo-grid" style="width:100%"></div>
    <div class="ava-chart-option"></div>
    </div>`;
  };

  /**
   * Hiển thị thông báo lỗi
   * @param {*} message - Nội dung thông báo
   * @param {*} botChat - Element chat bot
   */
  const renderErrorMessage = (message, botChat) => {
    const errorMsg = {message};
    window._aiBot.renderBotChatText(errorMsg, botChat);
  };

  /**
   * Hiển thị thông báo dạng HTML
   * @param {*} htmlContent - Nội dung HTML
   * @param {*} botChat - Element chat bot
   */
  const renderHtmlMessage = (htmlContent, botChat) => {
    const msg = {
      message: htmlContent,
      isHtml: true,
    };
    window._aiBot.renderBotChatText(msg, botChat);
  };

  /**
   * Kiểm tra lỗi trùng mã
   * @param {*} error - Lỗi cần kiểm tra
   * @param {*} codeField - Tên trường mã
   * @returns {Boolean} - Kết quả kiểm tra
   */
  const isDuplicateError = (error, codeField) => {
    return (
      error?.response?.data?.Error === 'VALIDATE' &&
      error?.response?.data?.Data?.Code === 'Duplicate' &&
      error?.response?.data?.Data?.Data &&
      error?.response?.data?.Data?.Data.length > 0 &&
      error?.response?.data?.Data?.Data[0].FieldName === codeField
    );
  };

  /**
   * Gắn sự kiện cho link danh mục
   * @param {*} botChat - Element chat bot
   * @param {*} store - Store danh mục (nếu có)
   * @param {*} config - Cấu hình danh mục
   */
  const bindDictionaryLinkEvent = (botChat, store, config) => {
    const {codeField, idField, formName} = config;

    setTimeout(() => {
      $(botChat)
        .find('.dictionary-link')
        .on('click', function () {
          const code = $(this).attr('data-code');
          const formNameAttr = $(this).attr('data-form') || formName;

          // Nếu có store thì tìm id theo code
          if (store && store.items) {
            const item = store.items.find(item => item[codeField] === code);
            if (item) {
              const param = {
                id: item[idField],
                mode: proxy.$ms.constant.FormState.Edit,
              };
              popupUtil.show(formNameAttr, param);
            }
          } else {
            // Nếu không có store thì mở form với code
            const param = {
              code: code,
              mode: proxy.$ms.constant.FormState.Edit,
            };
            popupUtil.show(formNameAttr, param);
          }
        });
    }, 100);
  };

  /**
   * Kiểm tra tính hợp lệ của tham số
   * @param {*} customParam - Tham số cần kiểm tra
   * @param {*} config - Cấu hình danh mục
   * @returns {Object} - Kết quả kiểm tra
   */
  const validateDictionaryParams = async (customParam, config) => {
    const {codeField, nameField, codeMaxLength, nameMaxLength, messages, displayNames} = config;

    // Sử dụng thông báo từ config hoặc thông báo mặc định
    const missingFieldsMsg = messages?.missingFields || 'Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã - Tên';
    const invalidLengthMsg = messages?.invalidLength || 'Độ dài mã hoặc tên không hợp lệ';

    // Lấy giá trị mã và tên
    const code = customParam.find(i => i.name === codeField)?.value?.trim();
    const name = customParam.find(i => i.name === nameField)?.value.trim();

    // Kiểm tra tồn tại
    if (!code || !name) {
      return {
        isValid: false,
        message: missingFieldsMsg,
      };
    }

    // Kiểm tra độ dài
    if (code.length > codeMaxLength || name.length > nameMaxLength) {
      let listInvalidFields = [];
      if (code.length > codeMaxLength) {
        listInvalidFields.push(displayNames.code);
      }
      if (name.length > nameMaxLength) {
        listInvalidFields.push(displayNames.name);
      }

      let invalidFields = proxy.$ms.commonFn.capitalizeFirstLetter(listInvalidFields.join('; '));

      return {
        isValid: false,
        message: invalidLengthMsg.replace('{0}', invalidFields),
      };
    }

    return {isValid: true};
  };

  /**
   * Xây dựng tham số để lưu danh mục
   * @param {*} customParam - Tham số đầu vào
   * @param {*} config - Cấu hình danh mục
   * @returns {Object} - Tham số để lưu
   */
  const buildSaveParam = (customParam, config) => {
    const {codeField, nameField, idField, defaultFields} = config;

    // Tạo model với các trường cơ bản
    const model = {
      state: proxy.$ms.constant.ModelState.Insert,
      EditVersion: 0,
      [idField]: proxy.$ms.commonFn.generateUUID(),
      [codeField]: customParam.find(i => i.name === codeField).value.trim(),
      [nameField]: customParam.find(i => i.name === nameField).value.trim(),
      ...defaultFields,
    };

    // Tạo tham số lưu
    return {
      Mode: proxy.$ms.constant.SaveMode.Save,
      Model: model,
      ReturnRecord: true,
      Ignores: [],
    };
  };

  /**
   * Xử lý khi lưu thành công
   * @param {*} result - Kết quả trả về
   * @param {*} code - Mã danh mục
   * @param {*} name - Tên danh mục
   * @param {*} botChat - Element chat bot
   * @param {*} config - Cấu hình danh mục
   */
  const handleSaveSuccess = (result, code, name, botChat, config, store) => {
    const {formName, messages, displayNames} = config;

    // Sử dụng thông báo từ config hoặc thông báo mặc định
    let successMsg = messages?.saveSuccess || 'Thông báo thêm thành công mã: {0}, tên: {1}.';

    // Thay thế placeholder với giá trị thực
    successMsg = successMsg.replace('{0}', code).replace('{1}', name);

    // Tạo HTML hiển thị kết quả
    const messageHtml = `
      <div>${successMsg}
        <a class="dictionary-link" data-code="${code}" data-form="${formName}">Xem chi tiết</a></div>
    `;

    renderHtmlMessage(messageHtml, botChat);

    // Thêm sự kiện click cho link
    bindDictionaryLinkEvent(botChat, store, config);
  };

  /**
   * Xử lý khi lưu thất bại
   * @param {*} error - Lỗi trả về
   * @param {*} code - Mã danh mục
   * @param {*} store - Store danh mục
   * @param {*} botChat - Element chat bot
   * @param {*} config - Cấu hình danh mục
   */
  const handleSaveError = (error, code, store, botChat, config) => {
    const {codeField, formName, messages} = config;

    console.error('Error in saving dictionary:', error);

    // Kiểm tra lỗi trùng mã
    if (isDuplicateError(error, codeField)) {
      // Sử dụng thông báo từ config hoặc thông báo mặc định
      let duplicateMsg = messages?.duplicateCode || 'Mã {0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.';
      let dupFieldName = messages?.duplicateCodeFieldName || 'mã';

      // Thay thế placeholder với giá trị thực
      duplicateMsg = duplicateMsg.replace('{0}', code);

      // Tạo HTML hiển thị lỗi
      const errorHtml = `
        <div>${duplicateMsg}
          <a class="dictionary-link" data-code="${code}" data-form="${formName}">Xem chi tiết ${dupFieldName} trùng</a></div>
      `;

      renderHtmlMessage(errorHtml, botChat);

      // Thêm sự kiện click cho link
      bindDictionaryLinkEvent(botChat, store, config);
    } else {
      // Lỗi khác - Sử dụng thông báo từ config hoặc thông báo mặc định
      const generalErrorMsg = messages?.generalError || 'Đã có lỗi xảy ra, vui lòng thực hiện lại';
      renderErrorMessage(generalErrorMsg, botChat);
    }
  };

  /**
   * Thực hiện lưu danh mục
   * @param {*} saveParam - Tham số lưu
   * @param {*} customParam - Tham số gốc
   * @param {*} botChat - Element chat bot
   * @param {*} config - Cấu hình danh mục
   */
  const saveDictionary = async (saveParam, customParam, botChat, config) => {
    const {storeFunction, codeField, nameField} = config;

    // Khởi tạo store
    const store = storeFunction();

    try {
      // Gọi API lưu
      const result = await store.insert(saveParam);

      // Xử lý kết quả thành công
      handleSaveSuccess(
        result,
        customParam.find(i => i.name === codeField).value.trim(),
        customParam.find(i => i.name === nameField).value.trim(),
        botChat,
        config,
        store,
      );
    } catch (error) {
      // Xử lý lỗi
      handleSaveError(error, customParam.find(i => i.name === codeField).value.trim(), store, botChat, config);
    }
  };

  /**
   * Lấy cấu hình mặc định dựa vào tham số
   * @param {*} customParam - Tham số đầu vào
   * @returns {Object} - Cấu hình danh mục
   */
  const getDefaultDictionaryConfig = customParam => {
    // Xác định loại danh mục dựa vào customParam
    // Ví dụ: nếu có accounting_object_code thì đây là đối tượng
    if (customParam.accounting_object_code) {
      return {
        storeFunction: useAccountingObjectStore,
        codeField: 'accounting_object_code',
        nameField: 'accounting_object_name',
        idField: 'accounting_object_id',
        formName: 'AccountingObjectListDetail',
        codeMaxLength: 20,
        nameMaxLength: 255,
        defaultFields: {
          is_employee: false,
          active: true,
        },
        // Thông báo tùy chỉnh
        messages: {
          missingFields: 'Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã đối tượng - Tên đối tượng',
          invalidLength: 'Mã đối tượng không được vượt quá 20 ký tự và tên đối tượng không được vượt quá 255 ký tự',
          duplicateCode: 'Mã đối tượng {0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
          saveSuccess: 'Thông báo thêm thành công mã đối tượng: {0}, tên đối tượng: {1}',
          generalError: 'Đã có lỗi xảy ra khi thêm đối tượng, vui lòng thực hiện lại',
        },
        displayNames: {
          code: 'mã đối tượng',
          name: 'tên đối tượng',
        },
      };
    }

    // Trường hợp không xác định được
    return null;
  };

  /**
   * Thêm nhanh danh mục qua giao diện chat
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin danh mục
   * @param {*} botChat - Element chat bot
   * @param {*} dictionaryConfig - Cấu hình danh mục cần thêm
   * vqphong - 02/04/2025
   */
  const quick_add_dictionary = async (msg, customParam, botChat, dictionaryConfig) => {
    // Lấy cấu hình hoặc sử dụng cấu hình mặc định
    const config = dictionaryConfig || getDefaultDictionaryConfig(customParam);

    // Validate thông tin
    const validationResult = await validateDictionaryParams(customParam, config);
    if (!validationResult.isValid) {
      renderErrorMessage(validationResult.message, botChat);
      return;
    }

    try {
      proxy.$ms.commonFn.mask();

      // Tạo param và thực hiện thêm mới
      const saveParam = buildSaveParam(customParam, config);
      await saveDictionary(saveParam, customParam, botChat, config);
    } catch (error) {
      console.error(`Unexpected error in quick_add_dictionary: ${error}`);
      renderErrorMessage('Đã có lỗi xảy ra, vui lòng thực hiện lại', botChat);
    } finally {
      proxy.$ms.commonFn.unmask();
    }
  };

  /**
   * Thêm nhanh danh mục đối tượng - Hàm tiện ích
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin danh mục
   * @param {*} botChat - Element chat bot
   * vqphong - 02/04/2025
   */
  const quick_add_dic_accounting_object = (msg, customParam, botChat) => {
    const config = {
      storeFunction: useAccountingObjectStore,
      codeField: 'accounting_object_code',
      nameField: 'accounting_object_name',
      idField: 'accounting_object_id',
      formName: 'AccountingObjectListDetail',
      codeMaxLength: 20,
      nameMaxLength: 255,
      defaultFields: {
        is_employee: false,
        active: true,
      },
      // Thông báo tùy chỉnh
      messages: {
        missingFields: 'Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã đối tượng - Tên đối tượng.',
        invalidLength:
          '{0} vượt quá ký tự cho phép. Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã đối tượng - Tên đối tượng.',
        duplicateCode: 'Mã đối tượng {0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
        duplicateCodeFieldName: 'mã',
        saveSuccess: 'Thông báo thêm thành công mã đối tượng: {0}, tên đối tượng: {1}.',
        generalError: 'Đã có lỗi xảy ra khi thêm đối tượng, vui lòng thực hiện lại.',
      },
      displayNames: {
        code: 'mã đối tượng',
        name: 'tên đối tượng',
      },
    };

    return quick_add_dictionary(msg, customParam, botChat, config);
  };

  /**
   * Thêm nhanh danh mục tài khoản ngân hàng, kho bạc
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin danh mục
   * @param {*} botChat - Element chat bot
   * vqphong - 02/04/2025
   */
  const quick_add_dic_bank_info = (msg, customParam, botChat) => {
    const config = {
      storeFunction: useBankInfoStore,
      codeField: 'bank_account',
      nameField: 'bank_name',
      idField: 'bank_info_id',
      formName: 'BankInfoDetail',
      codeMaxLength: 50,
      nameMaxLength: 255,
      defaultFields: {
        active: true,
      },
      // Thông báo tùy chỉnh
      messages: {
        missingFields: 'Bạn vui lòng cung cấp thông tin theo cấu trúc: Số tài khoản - Tên Kho bạc.',
        invalidLength:
          '{0} vượt quá ký tự cho phép. Bạn vui lòng cung cấp thông tin theo cấu trúc: Số tài khoản - Tên Kho bạc.',
        duplicateCode: 'Số tài khoản {0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
        duplicateCodeFieldName: 'Số tài khoản',
        saveSuccess: 'Thông báo thêm thành công số tài khoản: {0}, tên kho bạc: {1}.',
        generalError: 'Đã có lỗi xảy ra khi thêm tài khoản ngân hàng/kho bạc, vui lòng thực hiện lại.',
      },
      displayNames: {
        code: 'số tài khoản',
        name: 'tên kho bạc',
      },
    };

    return quick_add_dictionary(msg, customParam, botChat, config);
  };

  /**
   * Thêm nhanh danh mục nguồn kinh phí
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin danh mục
   * @param {*} botChat - Element chat bot
   * vqphong - 02/04/2025
   */
  const quick_add_dic_budget_source = (msg, customParam, botChat) => {
    const config = {
      storeFunction: useBudgetSourceStore,
      codeField: 'budget_source_code',
      nameField: 'budget_source_name',
      idField: 'budget_source_id',
      formName: 'BudgetSourceDetail',
      codeMaxLength: 20,
      nameMaxLength: 255,
      defaultFields: {
        active: true,
        is_parent: false,
      },
      // Thông báo tùy chỉnh
      messages: {
        missingFields: 'Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã nguồn kinh phí - Tên nguồn kinh phí.',
        invalidLength:
          '{0} vượt quá ký tự cho phép. Bạn vui lòng cung cấp thông tin theo cấu trúc: Mã nguồn kinh phí - Tên nguồn kinh phí.',
        duplicateCode: 'Mã nguồn kinh phí {0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
        duplicateCodeFieldName: 'nguồn kinh phí',
        saveSuccess: 'Thông báo thêm thành công mã nguồn kinh phí: {0}, tên nguồn kinh phí: {1}.',
        generalError: 'Đã có lỗi xảy ra khi thêm nguồn kinh phí, vui lòng thực hiện lại.',
      },
      displayNames: {
        code: 'mã nguồn kinh phí',
        name: 'tên nguồn kinh phí',
      },
    };

    return quick_add_dictionary(msg, customParam, botChat, config);
  };

  /**
   * Lấy năm từ ngày hạch toán hiện tại
   * @returns {number} Năm hiện tại
   */
  const getCurrentYear = () => {
    const contextStore = useContextStore();
    const postedDate = new Date(contextStore.postedDate);
    return postedDate.getFullYear();
  };

  /**
   * Kiểm tra đã có chứng từ hao mòn cho năm cụ thể chưa
   * @param {number} year - Năm cần kiểm tra
   * @returns {string|null} ID của chứng từ nếu đã tồn tại, null nếu chưa có
   */
  const checkExistingDepreciation = async year => {
    const result = await faVoucherDepreciationAPI.getDepreciationByYear(year);
    if (result && result !== '00000000-0000-0000-0000-000000000000') {
      return result;
    }
    return null;
  };

  /**
   * Hiển thị thông báo và link xem chi tiết cho chứng từ hao mòn đã tồn tại
   * @param {string} depreciationId - ID của chứng từ hao mòn
   * @param {number} year - Năm của chứng từ
   * @param {Element} botChat - Element chat bot
   */
  const showExistingDepreciationMessage = (depreciationId, year, botChat) => {
    const messageHtml = `
      <div>Đã tồn tại chứng từ tính hao mòn năm ${year}. 
        <a class="depreciation-link" data-id="${depreciationId}">Xem chi tiết</a>
      </div>
    `;

    renderHtmlMessage(messageHtml, botChat);

    // Thêm event listener để mở form chi tiết khi click vào link
    bindDepreciationLinkEvent(botChat);
  };

  /**
   * Lấy dữ liệu tài sản cần tính hao mòn cho năm cụ thể
   * @param {number} year - Năm cần tính hao mòn
   * @returns {Array} Danh sách tài sản cần tính hao mòn
   */
  const getDepreciationData = async year => {
    const pagination = true;
    const take = 1000; // Lấy nhiều bản ghi để đảm bảo tính toán đầy đủ
    const skip = 0;

    const data = await faVoucherDepreciationAPI.getDepreciationData(year, pagination, take, skip);

    return Array.isArray(data)
      ? data.map(i => {
          return {...i, state: proxy.$ms.constant.ModelState.Insert};
        })
      : [];
  };

  /**
   * Tính tổng số tiền hao mòn từ API thay vì từ danh sách tài sản
   * @param {number} year - Năm cần tính hao mòn
   * @returns {Promise<number>} Tổng số tiền hao mòn
   * vqphong - 03/04/2025
   */
  const calculateTotalAmount = async year => {
    try {
      const summaryRes = await faVoucherDepreciationAPI.getSummaryDepreciationData(year);
      if (summaryRes && summaryRes.SummaryData) {
        return summaryRes.SummaryData.amount;
      }
      return 0;
    } catch (error) {
      console.error('Error in calculateTotalAmount:', error);
      return 0;
    }
  };

  const latestDepreciationId = ref(null); // Biến lưu ID CT hao mòn mới nhất

  /**
   * Xây dựng tham số lưu chứng từ hao mòn
   * @param {Object} entity - Entity ban đầu
   * @param {Array} depreciationData - Dữ liệu tài sản cần tính hao mòn
   * @param {number} year - Năm cần tính hao mòn
   * @param {number} totalAmount - Tổng số tiền hao mòn
   * @returns {Object} Tham số lưu
   * vqphong - 03/04/2025
   */
  const buildDepreciationSaveParam = (entity, depreciationData, year, totalAmount) => {
    const refId = proxy.$ms.commonFn.generateUUID();
    latestDepreciationId.value = refId;
    const lastDayOfYear = moment(new Date(year, 11, 31)).format('YYYY-MM-DD') + 'T00:00:00';

    return {
      Mode: proxy.$ms.constant.SaveMode.SaveView,
      Model: {
        ...entity,
        state: proxy.$ms.constant.ModelState.Insert,
        EditVersion: 0,
        FAVoucherDepreciationDetails: depreciationData,
        FADataChangeDetails: [],
        ref_id: refId,
        ref_type: 73,
        is_posted: false,
        depreciation_year: year,
        depreciation_year_str: year.toString(),
        ref_date: lastDayOfYear,
        posted_date: lastDayOfYear,
        total_amount: totalAmount,
        description: `Hao mòn TSCĐ năm ${year}`,
      },
      ReturnRecord: true,
      Ignores: [],
      refTypes: 73,
    };
  };

  /**
   * Tạo và lưu chứng từ hao mòn mới
   * @param {Array} depreciationData - Dữ liệu tài sản cần tính hao mòn
   * @param {number} year - Năm cần tính hao mòn
   * @returns {Object} Kết quả lưu chứng từ
   * vqphong - 03/04/2025
   */
  const createDepreciationVoucher = async (depreciationData, year) => {
    // 1. Lấy entity ban đầu từ store
    const store = useFAVoucherCustomStore();
    const payload = {param: '{"RefTypeKey":73}', action: 'New', skip: 0, take: 10};
    const entity = await store.get(payload);

    // 2. Tính tổng số tiền hao mòn từ API thay vì tính từ danh sách tài sản
    const totalAmount = await calculateTotalAmount(year);

    // 3. Tạo tham số lưu
    const saveParam = buildDepreciationSaveParam(entity, depreciationData, year, totalAmount);

    // 4. Lưu chứng từ và ghi sổ
    await store.insert(saveParam).then(async res => {
      // thực hiện ghi sổ
      // tạo param ghi sổ
      const param = {
        ignoreAll: false,
        ignores: ['string'],
        data: {
          refType: 73,
          refId: latestDepreciationId.value,
          refNo: entity.ref_no,
        },
        subSystemCode: proxy.$ms.constant.SubSystemCode.FAVoucher,
      };

      // gọi api ghi sổ
      await store.posted(param).catch(err => console.log(err));
    });
  };

  /**
   * Hiển thị thông báo thành công và link xem chi tiết
   * @param {number} year - Năm của chứng từ
   * @param {Element} botChat - Element chat bot
   */
  const showSuccessMessage = (year, botChat) => {
    const depreciationId = latestDepreciationId.value;

    const successHtml = `
      <div>Tính hao mòn tài sản cố định năm ${year} thành công. 
        <a class="depreciation-link" data-id="${depreciationId}">Xem chi tiết</a>
      </div>
    `;

    renderHtmlMessage(successHtml, botChat);

    // Thêm event listener để mở form chi tiết khi click vào link
    bindDepreciationLinkEvent(botChat);
  };

  /**
   * Gắn sự kiện click cho link xem chi tiết chứng từ hao mòn
   * @param {Element} botChat - Element chat bot
   */
  const bindDepreciationLinkEvent = botChat => {
    setTimeout(() => {
      $(botChat)
        .find('.depreciation-link')
        .on('click', function () {
          const depreciationId = $(this).attr('data-id');
          popupUtil.show('FAVoucherDepreciationDetailFixedAsset', {
            mode: proxy.$ms.constant.FormState.View,
            id: depreciationId,
          });
        });
    }, 100);
  };

  /**
   * Hàm tính hao mòn tài sản cố định
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số tùy chỉnh
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const depreciation_fixed_assets = async (msg, customParam, botChat) => {
    try {
      proxy.$ms.commonFn.mask();
      // 1. Lấy năm từ ngày hạch toán hiện tại
      const currentYear = getCurrentYear();

      // 2. Kiểm tra đã có chứng từ hao mòn cho năm hiện tại chưa
      const existingDepreciation = await checkExistingDepreciation(currentYear);
      if (existingDepreciation) {
        // 3. Nếu đã có chứng từ hao mòn, hiển thị thông báo và link xem chi tiết
        showExistingDepreciationMessage(existingDepreciation, currentYear, botChat);
        return;
      }

      // 4. Lấy dữ liệu tài sản cần tính hao mòn
      const depreciationData = await getDepreciationData(currentYear);
      if (!depreciationData || depreciationData.length === 0) {
        // 5. Nếu không có dữ liệu, hiển thị thông báo
        renderErrorMessage('Chưa có số liệu để tính hao mòn.', botChat);
        return;
      }

      // 6. Tạo và lưu chứng từ hao mòn mới
      await createDepreciationVoucher(depreciationData, currentYear);

      // 7. Xử lý kết quả và hiển thị thông báo
      showSuccessMessage(currentYear, botChat);
    } catch (error) {
      console.error('Error in depreciation_fixed_assets:', error);
      renderErrorMessage('Đã có lỗi xảy ra, vui lòng thử lại.', botChat);
    } finally {
      proxy.$ms.commonFn.unmask();
    }
  };

  const quickTransferResults = ref(null); // Biến lưu kết quả kết chuyển nhanh

  onMounted(() => {
    EventBusGlobal.$on(GlobalEventName.quickTransfer, async res => {
      if (!res) return;
      quickTransferResults.value = res;
    });
  });

  /**
   * Kiểm tra đã có đủ các loại phiếu kết chuyển chưa
   * @param {Array} refTypes - Mảng các loại kết chuyển cần kiểm tra
   * @returns {Promise<Array>} - Mảng các phiếu kết chuyển đã tồn tại
   * vqphong - 04/04/2025
   */
  const checkExistingTransfers = async refTypes => {
    try {
      const contextStore = useContextStore();
      const postedYear = new Date(contextStore.postedDate).getFullYear();
      const suStore = useSUAccountTransferStore();
      const data = await suStore.getCurrentTransferVoucherList(refTypes, postedYear);
      return data || [];
    } catch (error) {
      console.error('Error in checkExistingTransfers:', error);
      return [];
    }
  };

  /**
   * Thực hiện kết chuyển nhanh các tài khoản
   * @param {Element} botChat - Element chat bot
   * @returns {Promise<Object>} - Kết quả kết chuyển
   * vqphong - 04/04/2025
   */
  const performQuickTransfer = async botChat => {
    try {
      const contextStore = useContextStore();
      const suStore = useSUAccountTransferStore();

      // Hiển thị thông báo đang xử lý
      const processingMsg = {
        message: 'Đang thực hiện kết chuyển tài khoản, vui lòng đợi...',
      };
      window._aiBot.renderBotChatText(processingMsg, botChat);

      // Thực hiện API kết chuyển nhanh
      const payload = {
        PostedDate: new Date(contextStore.postedDate),
      };

      // Gọi API và lấy ID của tiến trình
      const traceId = await suStore.makeQuickTransfers(payload);
      if (!traceId) {
        return null;
      }

      // Đợi kết quả từ API (tối đa 30 giây)
      let result = null;
      let attempts = 0;
      const maxAttempts = 6; // 30 giây (6 lần * 5 giây)

      while (!result && !quickTransferResults.value && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Đợi 5 giây
        result = await suStore.checkQuickTransfer(traceId);
        attempts++;
      }

      // Xóa cache khi đã hoàn thành
      if (result || quickTransferResults.value) {
        await suStore.checkQuickTransfer(traceId);
      }

      return result || quickTransferResults.value;
    } catch (error) {
      console.error('Error in performQuickTransfer:', error);
      return null;
    }
  };

  /**
   * Tạo HTML cho bảng kết quả kết chuyển
   * @param {Array} data - Dữ liệu kết quả
   * @param {boolean} isExistingVouchers - Cờ xác định đây là bảng chứng từ đã tồn tại
   * @returns {string} - HTML của bảng kết quả
   * vqphong - 04/04/2025
   */
  const buildTransferResultTable = (data, isExistingVouchers = false) => {
    if (!data || data.length === 0) {
      return '';
    }

    // Định nghĩa cột dựa vào trường hợp
    let columns;
    if (isExistingVouchers) {
      columns = [
        {dataField: 'ref_type', caption: 'Loại kết chuyển'},
        {dataField: 'ref_no', caption: 'Số CT', isLink: true},
        {dataField: 'is_posted', caption: 'Trạng thái ghi sổ'},
      ];
    } else {
      columns = [
        {dataField: 'ref_type', caption: 'Loại kết chuyển'},
        {dataField: 'status', caption: 'Trạng thái Ghi sổ'},
        {dataField: 'ref_no', caption: 'Số CT', isLink: true},
        {dataField: 'description', caption: 'Ghi chú'},
      ];
    }

    // Tạo HTML cho bảng
    let tableHtml = `
      <table class="ava-table">
        <thead>
          <tr>
    `;

    // Thêm tiêu đề cột
    columns.forEach(col => {
      tableHtml += `<th>${col.caption}</th>`;
    });

    tableHtml += `
          </tr>
        </thead>
        <tbody>
    `;

    // Thêm dữ liệu
    data.forEach(item => {
      tableHtml += '<tr>';

      columns.forEach(col => {
        let cellValue = item[col.dataField];

        // Xử lý hiển thị cho từng loại dữ liệu
        if (col.dataField === 'ref_type') {
          // Map mã ref_type sang tên
          const refTypeMap = {
            134: 'Kết chuyển hoạt động sự nghiệp',
            132: 'Kết chuyển cuối năm',
            130: 'Kết chuyển chênh lệch thu, chi ngân sách xã',
            136: 'Kết chuyển chênh lệch thu, chi ngân sách trong thời gian chỉnh lý',
            135: 'Quyết toán dự toán chi ngân sách cuối năm',
            133: 'Kết chuyển kết dư sang thu ngân sách xã',
          };
          cellValue = refTypeMap[cellValue] || cellValue;
        } else if (col.dataField === 'status') {
          // Map trạng thái ghi sổ
          if (cellValue === 3) {
            cellValue = 'Ghi sổ thành công';
          } else if (cellValue === 1) {
            cellValue = 'Chưa ghi sổ';
          } else {
            cellValue = cellValue || '';
          }
        } else if (col.dataField === 'is_posted') {
          // Map trạng thái ghi sổ
          if (cellValue === true) {
            cellValue = 'Đã ghi sổ';
          } else if (cellValue === false) {
            cellValue = 'Chưa ghi sổ';
          } else {
            cellValue = 'Không xác định';
          }
        }

        // Xử lý link
        if (col.isLink && item.ref_id) {
          tableHtml += `<td><a class="transfer-link" data-id="${item.ref_id}" data-ref-type="${item.ref_type}">${
            cellValue || ''
          }</a></td>`;
        } else {
          tableHtml += `<td>${cellValue || ''}</td>`;
        }
      });

      tableHtml += '</tr>';
    });

    tableHtml += `
        </tbody>
      </table>
    `;

    return tableHtml;
  };

  /**
   * Gán sự kiện click cho các link kết chuyển
   * @param {Element} botChat - Element chat bot
   * vqphong - 04/04/2025
   */
  const bindTransferLinkEvents = botChat => {
    setTimeout(() => {
      $(botChat)
        .find('.transfer-link')
        .on('click', function () {
          const refId = $(this).attr('data-id');
          const refType = $(this).attr('data-ref-type');

          popupUtil.show('SUAccountTransferDetail', {
            id: refId,
            mode: proxy.$ms.constant.FormState.View,
          });
        });
    }, 100);
  };

  /**
   * Xử lý và hiển thị kết quả của phiếu kết chuyển đã tồn tại
   * @param {Array} currentTransfers - Danh sách phiếu kết chuyển hiện có
   * @param {Element} botChat - Element chat bot
   * vqphong - 04/04/2025
   */
  const handleExistingTransfers = (currentTransfers, botChat) => {
    // Tạo HTML hiển thị danh sách chứng từ đã có
    const tableHtml = buildTransferResultTable(currentTransfers, true);
    const messageHtml = `
      <div>
        <p>Bạn đã thực hiện đủ các Phiếu Kết chuyển tài khoản/ Quyết toán</p>
        ${tableHtml}
      </div>
    `;

    // Hiển thị thông báo
    renderHtmlMessage(messageHtml, botChat);

    // Gắn sự kiện cho các link
    bindTransferLinkEvents(botChat);
  };

  // config cột trong grid kết quả kết chuyển nhanh
  const columnsQuickTransferResult = ref([
    {
      enum: 'RefType',
      width: 300,
      caption: 'Loại kết chuyển',
      sortable: true,
      dataField: 'ref_type',
      filterable: true,
      columnType: 12,
      formatType: 100,
      filterValue: [134, 132, 130, 136, 135, 133],
    },
    {
      caption: 'Trạng thái Ghi sổ',
      width: 150,
      sortable: true,
      dataField: 'status',
      filterable: true,
      formatType: 100,
      enum: 'PostedType',
    },
    {
      title: 'Số chứng từ',
      width: 136,
      caption: 'Số CT',
      sortable: true,
      dataField: 'ref_no',
      filterable: true,
      formatType: 12,
      linkedForm: 'fixtext',
    },
    {
      caption: 'Ghi chú',
      sortable: false,
      dataField: 'description',
      filterable: true,
      formatType: 12,
      autoResize: true,
    },
  ]);

  /**
   * Xử lý kết quả kết chuyển nhanh
   * @param {Object} response - Kết quả từ API
   * @param {Array} currentTransfers - Danh sách phiếu kết chuyển hiện có
   * @param {Element} botChat - Element chat bot
   * vqphong - 04/04/2025
   */
  const handleQuickTransferResults = (response, currentTransfers, botChat) => {
    // Parse response nếu là chuỗi
    let data = [];
    if (typeof response === 'string') {
      try {
        data = JSON.parse(response).Data || [];
      } catch {
        data = [];
      }
    } else {
      data = response.Data || response || [];
    }

    // Kiểm tra dữ liệu trả về
    if (!Array.isArray(data) || data.length === 0) {
      // Không có số liệu để kết chuyển
      if (currentTransfers && currentTransfers.length > 0) {
        // Nếu đã có một số phiếu, hiển thị những phiếu đó
        handleExistingTransfers(currentTransfers, botChat);
      } else {
        // Không có phiếu nào
        renderErrorMessage('Chưa có số liệu để kết chuyển tài khoản/Quyết toán.', botChat);
      }
      return;
    }

    // hiển thị kết quả ghi sổ
    showQuickTransferPostedResult(data);

    const resultHtml = `
      <div>
        <p>Phần mềm đã thực hiện kết chuyển nhanh. Vui lòng kiểm tra bảng kết quả trên màn hình.</p>
      </div>
    `;

    // Hiển thị kết quả
    renderHtmlMessage(resultHtml, botChat);
  };

  /**
   * Hiển thị kết quả ghi sổ kết chuyển nhanh
   * vqphong - 10/04/2025
   */
  const showQuickTransferPostedResult = data => {
    // Map dữ liệu để hiển thị
    data = data.map(x => ({
      ...x,
      ref_id: x.RefId,
      ref_type: x.RefType,
      ref_no: x.RefNo,
      ref_date: x.RefDate,
    }));

    const isSuccessAll = data.every(x => x.IsSuccess);
    if (isSuccessAll) {
      // Cập nhật status phục vụ hiển thị kết quả ghi sổ (nvthinh 31.1.2024)
      let showData = data.map(x => ({
        ...x,
        status: proxy.$ms.constant.PostResult.Success,
      }));
      // tất cả shi sổ thành công
      showBatchResult(showData);
    } else {
      let errorResult = data.filter(x => !x.IsSuccess);
      // có 1 trong số các PKC ghi sổ không thành công
      postedMultiErrorTransferAccount(errorResult, data, 1);
    }
  };

  /**
   * Hiển thị kết quả ghi sổ TH tất cả các PKC ghi sổ thành công
   * vqphong - 10/04/2025
   */
  const showBatchResult = data => {
    popupUtil.show('PostedBatchResult', {
      data: {
        gridData: data,
        type: 3,
        columns: columnsQuickTransferResult.value,
      },
      isQuickTransferAccount: true,
    });
  };

  /**
   * Show popup sau khi ghi sổ
   * vqphong - 10/04/2025
   */
  const postedMultiErrorTransferAccount = (error, records, type) => {
    const me = proxy;
    const data = {
      gridData: [],
      postedCount: records.length,
      postedErrorCount: error.length,
      postedSuccessCount: records.length - error.length,
      type: type,
    };

    if (records.length && records.length >= error.length) {
      const listErrorID = error.map(e => e.Index);
      records.forEach((record, i) => {
        if (listErrorID.includes(i)) {
          const er = error.find(e => e.Index == i);
          // Lỗi hiển thị trên grid
          let errorCode = '';
          let errorCodeArr = [];

          if (
            er.DataBusinessException &&
            er.DataBusinessException.Data &&
            Array.isArray(er.DataBusinessException.Data) &&
            er.DataBusinessException.Data.length > 0
          ) {
            // Danh sách mã hàng hóa đã kiểm tra
            const inventoryCodeArray = [];
            const outwardRefNoArr = [];
            // trong 1 bản ghi ghi sổ có thể có sinh ra lỗi ghi sổ tại nhiều bảng kê
            er.DataBusinessException.Data.forEach(item => {
              if (er.DataBusinessException.Code.includes(';')) {
                // Đổi câu thông báo chung thiếu thông tin hạch toán, lọc lấy 1 lần để ko lặp lại
                errorCode = me.$ms.constant.PostedErrorCode.Post_RequireAccountingInfo;
                if (!errorCodeArr.includes(errorCode)) {
                  errorCodeArr.push(errorCode);
                }
              } else {
                // Trường hợp lỗi nhập kho
                if (item.ref_no_outward) {
                  // Build câu thông báo gộp 2 bản ghi thành 1 nên gắn lại mảng lỗi = []
                  errorCodeArr = [];
                  outwardRefNoArr.push(item.ref_no_outward);
                }
                errorCode = me.$ms.commonFn.customErrorPosted(
                  er.DataBusinessException.Code,
                  item,
                  inventoryCodeArray,
                  outwardRefNoArr,
                );
                if (errorCode) {
                  errorCodeArr.push(errorCode);
                }
                if (item.inventory_item_code) {
                  inventoryCodeArray.push(item.inventory_item_code);
                }
              }
            });

            // Lấy bản ghi lỗi đầu lm thông tin master
            const dataErr = er.DataBusinessException.Data[0];
            let errCode = errorCodeArr.filter(x => x).join('');

            if (er.DataBusinessException.Code == 'Post_ValidFixedAssetIncrement') {
              errCode = me.$ms.constant.PostedErrorCode.Message_Post_ValidFixedAssetIncrement.format(
                dataErr.fixed_asset_code,
              );
            } else if (er.DataBusinessException.Code == 'Post_ValidFixedAssetDecrement') {
              errCode = me.$ms.constant.PostedErrorCode.Message_Post_ValidFixedAssetDecrement.format(
                dataErr.fixed_asset_code,
              );
            }

            // fomat lại dữ liệu trước khi đẩy vào grid dữ liệu lỗi
            const mess = {
              ref_id: dataErr.ref_id,
              ref_date: dataErr.ref_date,
              ref_type: dataErr.ref_type,
              ref_no_export: dataErr.ref_no,
              ref_no: dataErr.ref_no,
              errorCode: errCode,
              code: er.DataBusinessException.Code,
              status: me.$ms.constant.PostResult.NotSuccess,
            };
            data.gridData.push(mess);
          }
        } else {
          const mess = {
            ref_id: record.ref_id,
            ref_date: record.ref_date,
            ref_type: record.ref_type,
            ref_no: record.ref_no,
            status: me.$ms.constant.PostResult.Success,
          };
          data.gridData.push(mess);
        }
      });

      // show form danh sách lỗi ghi sổ, bỏ ghi
      showBatchResult(data.gridData);
    }
  };

  /**
   * Thực hiện kết chuyển nhanh tài khoản
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 04/04/2025
   */
  const quick_transfer_account = async (msg, customParam, botChat) => {
    try {
      // Đặt cờ để không hiển thị lại thông báo kết chuyển nhanh
      sessionStorage.setItem('bamboo_ava_on_transfer_voucher', 'true');

      proxy.$ms.commonFn.mask();
      // Định nghĩa các loại kết chuyển cần kiểm tra
      const refTypes = [134, 132, 130, 136, 135, 133];

      // 1. Kiểm tra đã có đủ các loại phiếu kết chuyển chưa
      const currentTransfers = await checkExistingTransfers(refTypes);

      // 2. Nếu đã có đủ 6 loại chứng từ
      if (currentTransfers && currentTransfers.length === 6) {
        handleExistingTransfers(currentTransfers, botChat);
        return;
      }

      // 3. Thực hiện kết chuyển nhanh nếu chưa có đủ chứng từ
      const result = await performQuickTransfer(botChat);

      // 4. Xử lý kết quả
      if (result) {
        handleQuickTransferResults(result, currentTransfers, botChat);
      } else if (currentTransfers && currentTransfers.length > 0) {
        // Trường hợp không tạo được thêm phiếu nhưng đã có một số phiếu
        handleExistingTransfers(currentTransfers, botChat);
      } else {
        // Trường hợp không có chứng từ nào
        renderErrorMessage('Chưa có số liệu để kết chuyển tài khoản/Quyết toán.', botChat);
      }
    } catch (error) {
      console.error('Error in quick_transfer_account:', error);
      renderErrorMessage('Có lỗi xảy ra khi thực hiện kết chuyển tài khoản/Quyết toán.', botChat);
    } finally {
      proxy.$ms.commonFn.unmask();
      sessionStorage.removeItem('bamboo_ava_on_transfer_voucher');
      quickTransferResults.value = null;
    }
  };

  /**
   * Kiểm tra chứng từ kết chuyển đã tồn tại chưa
   * @param {number} refType - Loại chứng từ kết chuyển
   * @returns {Promise<Array>} - Mảng các chứng từ đã tồn tại
   * vqphong - 03/04/2025
   */
  const checkExistingTransferDocument = async refType => {
    try {
      const contextStore = useContextStore();
      const currentYear = new Date(contextStore.postedDate).getFullYear();

      // Gọi API kiểm tra chứng từ đã tồn tại
      const response = await suGeneralVoucherApi.checkExistTransferVoucher(refType, currentYear);
      return response || [];
    } catch (error) {
      console.error(`Error in checkExistingTransferDocument for refType ${refType}:`, error);
      return [];
    }
  };

  /**
   * Lấy dữ liệu để tạo chứng từ kết chuyển
   * vqphong - 03/04/2025
   */
  const getTransferVoucherData = async (refType, payloadArg) => {
    try {
      // Tham số để lấy dữ liệu, chỉ lấy 10 bản ghi và bỏ qua 0 bản ghi
      const take = 10;
      const skip = 0;
      const paramForNewAction = `{"RefTypeKey":${refType}}`;

      // Gọi API lấy dữ liệu để tạo chứng từ
      const response = await suGeneralVoucherApi.getBalances(payloadArg, take, skip, paramForNewAction);
      return response || {SummaryData: []};
    } catch (error) {
      console.error(`Error in getTransferVoucherData for refType ${refType}:`, error);
      return {SummaryData: []};
    }
  };

  /**
   * Xây dựng tham số để tạo chứng từ kết chuyển
   * @param {Object} response - Dữ liệu để tạo chứng từ
   * @param {number} refType - Loại chứng từ kết chuyển
   * @param {string} description - Mô tả chứng từ
   * @returns {Object} - Tham số để tạo chứng từ
   * vqphong - 03/04/2025
   */
  const buildTransferVoucherParam = (response, refType, description, payloadArg) => {
    // Lấy ngày cuối cùng của năm hạch toán hiện tại
    const contextStore = useContextStore();
    const currentYear = new Date(contextStore.postedDate).getFullYear();
    const lastDayOfYear = moment(new Date(currentYear, 11, 31)).format('YYYY-MM-DD') + 'T00:00:00';

    // Lấy tổng số tiền từ SummaryData
    let amount = 0;
    if (response.SummaryData && response.SummaryData.length > 0) {
      amount = response.SummaryData[0].total_amount || 0;
    }

    // Xây dựng tham số để tạo chứng từ
    return {
      Mode: 2, // SaveMode.Save
      Model: {
        ...response,
        amount: amount,
        description: description,
        posted_date: lastDayOfYear,
        ref_date: lastDayOfYear,
        ParamGetAllDetaill: payloadArg,
      },
      ReturnRecord: true,
      Ignores: [],
      refTypes: refType,
    };
  };

  /**
   * Tạo chứng từ kết chuyển
   * @param {Object} param - Tham số để tạo chứng từ
   * @returns {Promise<Object>} - Kết quả tạo chứng từ
   * vqphong - 03/04/2025
   */
  const createTransferVoucher = async param => {
    try {
      const suAccountStore = useSUAccountTransferStore();
      const res = await suAccountStore.insert(param);

      // thực hiện ghi sổ
      // tạo param ghi sổ
      const paramPosted = {
        ignoreAll: false,
        ignores: ['string'],
        data: {
          refType: param?.Model?.ref_type,
          refId: param?.Model?.ref_id,
          refNo: param?.Model?.ref_no,
        },
        subSystemCode: proxy.$ms.constant.SubSystemCode.SUAccountTransfer,
      };

      // gọi api ghi sổ
      await suAccountStore.posted(paramPosted).catch(err => console.log(err));

      return res;
    } catch (error) {
      console.error('Error in createTransferVoucher:', error);
      throw error;
    }
  };

  /**
   * Hiển thị thông báo khi chứng từ đã tồn tại
   * @param {Array} response - Mảng các chứng từ đã tồn tại
   * @param {Element} botChat - Element chat bot
   * @param {string} title - Tiêu đề loại kết chuyển
   * @param {number} year - Năm hạch toán hiện tại
   * vqphong - 03/04/2025
   */
  const showExistingTransferMessage = (response, botChat, title, year) => {
    if (!response || response.length === 0) return;

    // Lấy thông tin chứng từ đầu tiên
    const refId = response[0].ref_id;
    const messageHtml = `
      <div>Đã tồn tại ${title} năm ${year}. 
        <a class="transfer-link" data-id="${refId}">Xem chi tiết</a>
      </div>
    `;

    // Hiển thị thông báo
    renderHtmlMessage(messageHtml, botChat);

    // Gắn sự kiện click cho link
    bindTransferVoucherLinkEvent(botChat);
  };

  /**
   * Hiển thị thông báo khi không có dữ liệu
   * @param {Element} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const showNoDataMessage = botChat => {
    renderErrorMessage('Chưa có số liệu để kết chuyển tài khoản.', botChat);
  };

  /**
   * Hiển thị thông báo khi tạo chứng từ kết chuyển thành công
   * @param {Object} result - Kết quả tạo chứng từ
   * @param {Element} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const showTransferSuccessMessage = (result, botChat) => {
    if (!result) return;

    // Lấy ID của chứng từ vừa tạo
    const refId = result.ref_id || (result.Model && result.Model.ref_id);
    if (!refId) return;

    // Tạo HTML thông báo
    const messageHtml = `
      <div>Tạo phiếu kết chuyển thành công. 
        <a class="transfer-link" data-id="${refId}">Xem chi tiết</a>
      </div>
    `;

    // Hiển thị thông báo
    renderHtmlMessage(messageHtml, botChat);

    // Gắn sự kiện click cho link
    bindTransferVoucherLinkEvent(botChat);
  };

  /**
   * Gắn sự kiện click cho link xem chi tiết chứng từ kết chuyển
   * @param {Element} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const bindTransferVoucherLinkEvent = botChat => {
    setTimeout(() => {
      $(botChat)
        .find('.transfer-link')
        .on('click', function () {
          const refId = $(this).attr('data-id');

          // Mở form chi tiết
          popupUtil.show('SUAccountTransferDetail', {
            id: refId,
            mode: proxy.$ms.constant.FormState.View,
          });
        });
    }, 100);
  };

  /**
   * Hàm cơ sở để tạo chứng từ kết chuyển, có thể tái sử dụng cho các loại kết chuyển khác
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * @param {number} refType - Loại chứng từ kết chuyển
   * @param {string} title - Tiêu đề hiển thị
   * @param {string} description - Mô tả chứng từ
   * vqphong - 03/04/2025
   */
  const createTransferVoucherBase = async (msg, customParam, botChat, refType, businessType, title, description) => {
    try {
      proxy.$ms.commonFn.mask();
      // 1. Lấy năm hạch toán hiện tại
      const contextStore = useContextStore();
      const currentYear = new Date(contextStore.postedDate).getFullYear();

      // 2. Kiểm tra chứng từ đã tồn tại chưa
      const existingTransfer = await checkExistingTransferDocument(refType);

      // 3. Nếu đã tồn tại, hiển thị thông báo với link
      if (existingTransfer && existingTransfer.length > 0) {
        showExistingTransferMessage(existingTransfer, botChat, title, currentYear);
        return;
      }

      // payload để lấy DL chi tiết tạo chứng từ
      let payloadArg = {BusinessType: businessType, ListEdit: [], PostedDate: contextStore.postedDate};

      // 4. Nếu chưa tồn tại, lấy dữ liệu để tạo chứng từ
      const transferData = await getTransferVoucherData(refType, payloadArg);

      // 5. Kiểm tra có dữ liệu không
      if (!transferData || !transferData.SummaryData || transferData.SummaryData.length <= 0) {
        showNoDataMessage(botChat);
        return;
      }

      // 6. Tạo tham số và thực hiện tạo chứng từ
      const param = buildTransferVoucherParam(transferData, refType, description, payloadArg);
      const result = await createTransferVoucher(param);

      // 7. Hiển thị thông báo thành công
      showTransferSuccessMessage(result, botChat);
    } catch (error) {
      console.error(`Error in createTransferVoucherBase for refType ${refType}:`, error);
      renderErrorMessage('Đã có lỗi xảy ra, vui lòng thử lại.', botChat);
    } finally {
      proxy.$ms.commonFn.unmask();
    }
  };

  /**
   * Tạo chứng từ kết chuyển hoạt động sự nghiệp
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_activity = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TransferActivity,
      BusinessType.TransferActivity,
      'Kết chuyển hoạt động sự nghiệp',
      'Kết chuyển hoạt động sự nghiệp',
    );
  };

  /**
   * Tạo chứng từ kết chuyển cuối năm
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_closing = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TranferClosing,
      BusinessType.TranferClosing,
      'Kết chuyển cuối năm',
      'Kết chuyển cuối năm',
    );
  };

  /**
   * Tạo chứng từ kết chuyển chênh lệch thu, chi ngân sách xã
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_receipt_clear = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TranferReceiptClear,
      BusinessType.TranferReceiptClear,
      'Kết chuyển chênh lệch thu, chi ngân sách xã',
      'Kết chuyển chênh lệch thu, chi ngân sách xã',
    );
  };

  /**
   * Tạo chứng từ kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_receipt_clear_month13 = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TranferReceiptClearInMonth13,
      BusinessType.TranferReceiptClearInMonth13,
      'Kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý',
      'Kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý',
    );
  };

  /**
   * Tạo chứng từ quyết toán dự toán chi ngân sách cuối năm
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_begining = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TransferBegining,
      BusinessType.TransferBegining,
      'Quyết toán dự toán chi ngân sách cuối năm',
      'Quyết toán dự toán chi ngân sách cuối năm',
    );
  };

  /**
   * Tạo chứng từ kết chuyển kết dư sang thu ngân sách xã
   * @param {*} msg - Element tin nhắn
   * @param {*} customParam - Tham số chứa thông tin
   * @param {*} botChat - Element chat bot
   * vqphong - 03/04/2025
   */
  const create_transfer_budget_balance = (msg, customParam, botChat) => {
    return createTransferVoucherBase(
      msg,
      customParam,
      botChat,
      RefType.TransferBudgetBalance,
      BusinessType.TransferBudgetBalance,
      'Kết chuyển kết dư sang thu ngân sách xã',
      'Kết chuyển kết dư sang thu ngân sách xã',
    );
  };

  return {
    cash_payment_receipt_report,
    budget_plan_report,
    change_property,
    show_unit_options,
    show_cash_grid_detail,
    quick_add_dic_accounting_object,
    quick_add_dic_bank_info,
    quick_add_dic_budget_source,
    depreciation_fixed_assets,
    quick_transfer_account,
    create_transfer_activity,
    create_transfer_closing,
    create_transfer_receipt_clear,
    create_transfer_receipt_clear_month13,
    create_transfer_begining,
    create_transfer_budget_balance,
  };
};
